import { useQuery } from "@tanstack/react-query";
import { client_v2 } from "utils/api";
import getGdnStatus from "pages/Dashboard/const/getGdnStatus";
import { Loader } from "components";

const NotCompletedOldestThanThreeDays = () => {
  const { isLoading, isFetching, data } = useQuery(
    ["dashboard_gdns_not_completed_oldest_than_three_days"],
    () =>
      client_v2.get(
        "/stats/dashboard_gdns_not_completed_oldest_than_three_days"
      ),
    {
      select: (res) => res.data,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );

  const is_loading = isLoading || isFetching;

  return (
    <div className="dashboard">
      <div className="dashboard__header">
        <h2 className="dashboard__title heading">
          Zamówienia w kompletacji starsze niż 3 dni
        </h2>
        {is_loading && <Loader size="20" />}
      </div>
      <table className="table table-sm">
        <thead className="table__header">
          <tr>
            <th width="25%">ID</th>
            <th width="25%">Data</th>
            <th width="25%">Pack</th>
            <th width="25%">Picker/Packer</th>
          </tr>
        </thead>
        {data?.length > 0 && (
          <tbody className="table__body">
            {data.map(
              ({
                id,
                identifier,
                prepared_at_date,
                gdn_pack_id,
                status,
                gdn_pack_picker_full_name,
                gdn_pack_packer_full_name,
              }) => {
                return (
                  <tr key={identifier}>
                    <td>
                      <p>
                        <a
                          className="link"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`/packing/gdn/${id}`}
                        >
                          {identifier}
                        </a>
                      </p>
                      <p>
                        <span
                          className={`label label--${
                            getGdnStatus(status).color
                          }`}
                          style={{
                            padding: "2px 4px",
                          }}
                        >
                          <span className="text-10">
                            {getGdnStatus(status).name}
                          </span>
                        </span>
                      </p>
                    </td>
                    <td>
                      <p>{prepared_at_date}</p>
                    </td>
                    <td>
                      {gdn_pack_id ? (
                        <>
                          <a
                            className="link"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`/packing/gdn_pack/${gdn_pack_id}`}
                          >
                            {gdn_pack_id}
                          </a>
                        </>
                      ) : (
                        <p className="text-11">brak</p>
                      )}
                    </td>
                    <td>
                      <p>{gdn_pack_picker_full_name || "-"}</p>
                      <p>{gdn_pack_packer_full_name || "-"}</p>
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
        )}
      </table>
    </div>
  );
};

export default NotCompletedOldestThanThreeDays;
